/* eslint semi:0 */
import userStore from '../../stores/userStore'
import { queryString } from '../../../utils/window'
import { externalScriptsConfig } from '../../config/externalScripts'
import { makeSafeFn, allTrue } from '../../../utils/fn'
import { external as externalScriptLoader } from '../../../utils/script'
import AnalyticsBaseService from '../../services/analytics/analyticsBaseService'
import { locale, AVAILABLE_LOCALES } from '../../../providers/i18nProvider/i18nProvider'
import { get as getFromPdo, isSupportedForDomain } from '../../../application/pageDataObject'

/* eslint-disable camelcase, key-spacing, no-multi-spaces, lines-around-comment, */
const AGOF_DEFAULT_PARAMS = {
  sv: 'i2',
  st: 'ftbpro',
}
const AGOF_DEFAULT_TAG = { cp: 'dTxUcCpOqKyFz02', co: '/other' }
const AGOF_STATIC_PAGE_TAG = { cp: 'dTxRcCpOqKyFz20serv', co: '/service' }
const AGOF_TAGS_DICTIONARY = {
  league: AGOF_DEFAULT_TAG,
  homepage: { cp: 'dTxRcHpOqKyFz02home', co: '/homepage', sv: 'ke' },
  league_articles: { cp: 'dTxUcCpOqKyFz02arti', co: '/artikel' },
  league_leaderboard: { cp: 'dTxUcCpOqKyFz27auto', co: '/autoren' },
  team: { cp: 'dTxUcCpOqKyFz02mann', co: '/mannschaften' },
  team_articles: { cp: 'dTxUcCpOqKyFz02arti', co: '/artikel' },
  users: { cp: 'dTxUcCpOqKyFz27prof', co: '/profile' },
  post: { cp: 'dTxUcCpOqKyFz02arti', co: '/meldungen' },
  about: AGOF_STATIC_PAGE_TAG,
  writersfaq: AGOF_STATIC_PAGE_TAG,
  rules: AGOF_STATIC_PAGE_TAG,
  terms: AGOF_STATIC_PAGE_TAG,
  contact: AGOF_STATIC_PAGE_TAG,
  privacy_policy: AGOF_STATIC_PAGE_TAG,
  mobile_apps: AGOF_STATIC_PAGE_TAG,
  affiliates: AGOF_STATIC_PAGE_TAG,
}
/* eslint-enable */

// NOTICE: this class should be (and is) used only when not in native app
export default class AgofService extends AnalyticsBaseService {
  constructor(...args) {
    super(...args)
    if (this.shouldReportPageview()) {
      this.agofLoader = externalScriptLoader.load({ name: externalScriptsConfig.agof.name })
    }
  }

  get className() {
    return 'AgofService'
  }

  pageViewed() {
    if (this.shouldReportPageview()) {
      this.trackEvent(this.pageViewData)
    }
  }

  shouldReportPageview() {
    const { forceAgofReport } = queryString
    return (
      forceAgofReport ||
      allTrue(
        isSupportedForDomain('Agof'),
        locale === AVAILABLE_LOCALES.DE,
        getFromPdo('config.env') !== 'development'
      )
    )
  }

  get pageViewData() {
    const currentTag = AGOF_TAGS_DICTIONARY[getFromPdo('page.type')] || AGOF_DEFAULT_TAG
    const tagWithDefaults = { ...AGOF_DEFAULT_PARAMS, ...currentTag }
    const { sha1 } = userStore.state
    if (sha1) {
      tagWithDefaults.mc = sha1
    }
    return tagWithDefaults
  }

  trackEvent(data) {
    if (this.shouldReportPageview()) {
      this.logAnalytics(data)
      this.agofLoader(makeSafeFn(() => window.iom.c(data, 2)))
    }
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/analytics/agofService.js